import { render, staticRenderFns } from "./s7bbs.vue?vue&type=template&id=227cc120&scoped=true&"
import script from "./s7bbs.vue?vue&type=script&lang=js&"
export * from "./s7bbs.vue?vue&type=script&lang=js&"
import style0 from "./s7bbs.vue?vue&type=style&index=0&id=227cc120&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227cc120",
  null
  
)

export default component.exports